



















import { Component, Vue, Prop } from 'vue-property-decorator'
import { BSpinner } from 'bootstrap-vue'

@Component({
	components: {
		BSpinner,
	},
})
export default class ProductImage extends Vue {
	@Prop({ type: String }) readonly src!: string

	private isLoaded: boolean = false

	onImageLoaded() {
		this.isLoaded = true
	}

	onImageLoadError() {
		this.isLoaded = true
	}
}
